// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2Dcfo","row":"styles_row__1FgjQ"};